"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
const initZoom = () => __async(null, null, function* () {
  console.log("\u{1F680} Initializing Zoom SDK...");
  const zoomContainer = document.getElementById("zoom-meeting-container");
  if (!zoomContainer) {
    console.error("\u274C Zoom container not found!");
    return;
  }
  const meetingData = JSON.parse(zoomContainer.dataset.meeting || "{}");
  const sdkKey = zoomContainer.dataset.zoomSdkKey;
  console.log("\u{1F4CB} Meeting Data:", meetingData);
  console.log("\u{1F511} SDK Key:", sdkKey ? "\u2713 Present" : "\u2717 Missing");
  if (!meetingData.meetingNumber || !sdkKey) {
    console.error("\u274C Missing required data: meetingNumber or SDK key");
    showError("Missing meeting configuration. Please refresh and try again.");
    return;
  }
  try {
    const client = ZoomMtgEmbedded.createClient();
    yield client.init({
      zoomAppRoot: zoomContainer,
      language: "en-US",
      patchJsMedia: true,
      leaveUrl: window.location.href
    });
    console.log("\u2705 SDK Initialized");
    setupJoinButton(client, meetingData);
    setupLeaveButton(client);
  } catch (error) {
    console.error("\u274C Error initializing SDK:", error);
    showError(`Error initializing meeting: ${extractErrorMessage(error)}`);
  }
});
function setupJoinButton(client, meetingData) {
  const joinButton = document.getElementById("zoom-join-button");
  if (!joinButton) return;
  joinButton.addEventListener("click", () => __async(null, null, function* () {
    console.log("\u{1F7E2} Join button clicked");
    joinButton.disabled = true;
    joinButton.setAttribute("aria-disabled", "true");
    joinButton.textContent = "Joining...";
    announceToScreenReader("Joining meeting, please wait...");
    try {
      const response = yield fetch(`/meetings/${meetingData.id}/signature`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const { signature } = yield response.json();
      console.log("\u{1F510} Signature received");
      yield client.join({
        signature,
        meetingNumber: meetingData.meetingNumber,
        password: meetingData.password,
        userName: meetingData.userName,
        userEmail: meetingData.userEmail
      });
      console.log("\u2705 Successfully joined meeting");
      announceToScreenReader("Successfully joined meeting");
      document.getElementById("zoom-join-button").style.display = "none";
      const leaveButton = document.getElementById("zoom-leave-button");
      leaveButton.style.display = "block";
      setTimeout(() => leaveButton.focus(), 100);
    } catch (error) {
      console.error("\u274C Error in join flow:", error);
      const errorMessage = `Error joining meeting: ${extractErrorMessage(error)}`;
      showError(errorMessage);
      announceToScreenReader(errorMessage);
      resetJoinButton(joinButton);
    }
  }));
}
function setupLeaveButton(client) {
  const leaveButton = document.getElementById("zoom-leave-button");
  if (!leaveButton) return;
  leaveButton.addEventListener("click", () => __async(null, null, function* () {
    console.log("\u{1F534} Leave button clicked");
    leaveButton.disabled = true;
    leaveButton.setAttribute("aria-disabled", "true");
    announceToScreenReader("Leaving meeting...");
    try {
      yield client.leaveMeeting();
      console.log("\u2705 Left meeting");
      announceToScreenReader("Left meeting successfully");
      leaveButton.style.display = "none";
      const joinButton = document.getElementById("zoom-join-button");
      joinButton.style.display = "block";
      joinButton.disabled = false;
      joinButton.removeAttribute("aria-disabled");
      setTimeout(() => joinButton.focus(), 100);
    } catch (error) {
      console.error("\u274C Error leaving:", error);
      const errorMessage = `Error leaving meeting: ${extractErrorMessage(error)}`;
      showError(errorMessage);
      announceToScreenReader(errorMessage);
      leaveButton.disabled = false;
      leaveButton.removeAttribute("aria-disabled");
    }
  }));
}
function resetJoinButton(button) {
  button.disabled = false;
  button.removeAttribute("aria-disabled");
  button.textContent = "Join Meeting";
  setTimeout(() => button.focus(), 100);
}
function extractErrorMessage(error) {
  if (typeof error === "string") {
    return error;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  if (error && typeof error === "object") {
    if (error.message && typeof error.message === "string") {
      return error.message;
    }
    if (error.error && typeof error.error === "string") {
      return error.error;
    }
    if (error.reason && typeof error.reason === "string") {
      return error.reason;
    }
    if (error.errorMessage && typeof error.errorMessage === "string") {
      return error.errorMessage;
    }
    try {
      const stringified = JSON.stringify(error);
      if (stringified && stringified !== "{}") {
        return stringified;
      }
    } catch (e) {
    }
  }
  return "An unexpected error occurred. Please try again.";
}
function showError(message) {
  const errorDiv = document.getElementById("zoom-error");
  if (errorDiv) {
    errorDiv.textContent = message || "An error occurred. Please try again.";
    errorDiv.style.display = "block";
    errorDiv.setAttribute("tabindex", "-1");
    errorDiv.focus();
  }
}
function announceToScreenReader(message) {
  let announcer = document.getElementById("zoom-announcer");
  if (!announcer) {
    announcer = document.createElement("div");
    announcer.id = "zoom-announcer";
    announcer.className = "sr-only";
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("aria-atomic", "true");
    document.body.appendChild(announcer);
  }
  announcer.textContent = "";
  setTimeout(() => {
    announcer.textContent = message;
  }, 100);
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initZoom);
} else {
  initZoom();
}
